import React, {useContext} from "react"
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Button from "@amzn/meridian/button";
import Text from "@amzn/meridian/text";
import {RouteDetailContext} from "./context/RouteDetailContext";
import {FormattedMessage} from "react-intl";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {getStationCode} from "../network/NetworkUtil";
import {AlertContext} from "../alert/context/AlertContext";
import {TOP_PRIORITY} from "../util/Constants";

const RouteMetadata = (props) => {
    const {viewModelRD, dispatchRD} = useContext(RouteDetailContext)
    const {configViewModel} = useContext(CapabilityContext)
    const {alertDispatch} = useContext(AlertContext)

    const parseStationCode = (stationCode) => {
        if (stationCode && stationCode !== "NA") {
            return stationCode
        }
        return getStationCode();
    }

    const executeAction = (operation) => {
        switch (operation) {
            case "Sideline":
                dispatchRD({
                    type: 'SIDELINE_ROUTE',
                    data: {
                        dispatcher: dispatchRD,
                        routeId: props.route.routeId,
                        stationCode: parseStationCode(props.route.stationCode),
                        baseUrl: configViewModel.baseUrl,
                        alertDispatch: alertDispatch,
                        stationConfig: configViewModel.stationConfig
                    }
                })
                return;
            case "PrioritizeRoute":
                dispatchRD({
                    type: 'PRIORITIZE_ROUTE',
                    data: {
                        dispatcher: dispatchRD,
                        routeId: props.route.routeId,
                        stationCode: parseStationCode(props.route.stationCode),
                        position: TOP_PRIORITY,
                        baseUrl: configViewModel.baseUrl,
                        alertDispatch: alertDispatch,
                        stationConfig: configViewModel.stationConfig
                    }
                })
                return;
            case "CutRoute":
                dispatchRD({
                    type: 'CUT_ROUTE',
                    data: {
                        dispatcher: dispatchRD,
                        routeId: props.route.routeId,
                        stationCode: parseStationCode(props.route.stationCode),
                        baseUrl: configViewModel.baseUrl,
                        alertDispatch: alertDispatch,
                        stationConfig: configViewModel.stationConfig
                    }
                });
                return;
            default:
                return;
        }
    }

    return (
        <div>
            <Row widths={["grid-6"]} spacingInset="small none small">
                <Heading level={3} type="h600" alignment="left">{props.route.code}</Heading>
                <Button data-id="Sideline" onClick={() => executeAction("Sideline")} type="tertiary" size="medium"
                        disabled={false}>
                    <FormattedMessage id="routeInfo.sideline" defaultMessage="Sideline"/>
                </Button>
                <Button data-id="CutRoute" onClick={() => executeAction("CutRoute")} type="tertiary" size="medium"
                        disabled={false}>
                    <FormattedMessage id="routeInfo.cutRoute" defaultMessage="Cut route"/>
                </Button>
                <Button data-id="PrioritizeRoute" onClick={() => executeAction("PrioritizeRoute")} type="tertiary"
                        size="medium" disabled={false}>
                    <FormattedMessage id="routeInfo.prioritizeRoute" defaultMessage="Prioritize staging"/>
                </Button>
            </Row>
            <Row widths={["grid-2", "grid-10"]} alignmentVertical="top" spacingInset="medium none none none">
                <Text type="h100">
                    <FormattedMessage id="routeInfo.status" defaultMessage="Status"/>
                </Text>
                <Text type="b200">{props.route.status !== "NA" ? decodeURIComponent(props.route.status) : "..."}</Text>
            </Row>
            <Row widths={["grid-2", "grid-10"]} alignmentVertical="top" spacingInset="medium none none none">
                <Text type="h100">
                    <FormattedMessage id="routeInfo.location" defaultMessage="Location"/>
                </Text>
                <Text
                    type="b200">{props.route.location !== "NA" ? decodeURIComponent(props.route.location) : "..."}</Text>
            </Row>
            <Row widths={["grid-2", "grid-10"]} alignmentVertical="top" spacingInset="medium none none none">
                <Text type="h100">
                    <FormattedMessage id="routeInfo.hazmatWeight" defaultMessage="Hazmat Weight"/>
                </Text>
                <Text type="b200">{viewModelRD.hazmatWeight !== '...' ? `${viewModelRD.hazmatWeight} kg` : "..."}</Text>
            </Row>
        </div>
    );
}

export default RouteMetadata


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/RouteMetadata.js